import { Link } from 'react-router-dom';

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=stylish%20abstract%20gradient%20banner%20of%20korean%20webtoon%20comic%20book%20pages%20in%20deep%20teal%20and%20muted%20coral%20tones%2C%20minimal%20editorial%20background%20with%20soft%20light%20and%20space%2C%20calm%20modern%20illustration&width=1800&height=700&seq=manhwa-cta-bg&orientation=landscape"
          alt="韩漫推荐横幅背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-900/80" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50">还在纠结看什么韩漫？</h2>
        <p className="mt-4 text-background-200 max-w-xl mx-auto text-sm md:text-base">
          从六大题材出发，按你的心情和口味选择，总有一部韩漫会击中你的内心。现在就开启你的韩漫之旅。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="h-11 px-6 rounded-full bg-accent-500 text-background-50 text-sm font-medium flex items-center whitespace-nowrap hover:bg-accent-600 transition-colors"
          >
            开始浏览题材
          </Link>
          <Link
            to="/about"
            className="h-11 px-6 rounded-full border border-background-300 text-background-50 text-sm font-medium flex items-center whitespace-nowrap hover:bg-background-50/10 transition-colors"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}